<p-toast position="top-right" styleClass="picking-list-toast" />

<div class="sticky-toolbar mb-8 text-[14px]">
        <p-toolbar class="text-[14px] p-0">
    <ng-template #start>
      <button
        *ngIf="!creditLimitBlocked && (!useM3DeliveryNote || m3DeliveryNoteLoaded)"
        pButton
        type="button"
        icon="pi pi-print"
        label="Print"
        class="p-button-sm p-button-secondary"
        (click)="printPickingList()"
      ></button>
      <button
        *ngIf="!creditLimitBlocked && useM3DeliveryNote && m3DeliveryNoteRetryVisible"
        pButton
        type="button"
        icon="pi pi-refresh"
        label="Retry"
        class="p-button-sm p-button-secondary ml-2"
        (click)="retryM3DeliveryNote()"
      ></button>
      <button
        *ngIf="!creditLimitBlocked && canShowProcessPicklist"
        pButton
        type="button"
        icon="pi pi-check-square"
        label="Change and Create Invoice"
        class="p-button-sm p-button-secondary ml-2"
        pTooltip="Shown when both M3 statuses are 44. Hidden when both are above 44."
        [disabled]="processPicklistLoading || processPicklistProcessing || processPicklistConfirming"
        (click)="openProcessPicklist()"
      ></button>
      <button
        *ngIf="!creditLimitBlocked && canShowProcessPicklist"
        pButton
        type="button"
        icon="pi pi-verified"
        label="Generate Invoice"
        class="p-button-sm p-button-secondary ml-2"
        pTooltip="Shown when both M3 statuses are 44. Hidden when both are above 44."
        [disabled]="processPicklistLoading || processPicklistProcessing || processPicklistConfirming"
        (click)="requestConfirmPicklistFromToolbar()"
      ></button>
      <div *ngIf="!useM3DeliveryNote" style="display: inline-block; margin-left: 16px;">
  <label for="languageSelect" style="margin-right: 8px;">Language:</label>
  <select id="languageSelect" [(ngModel)]="selectedLanguage">
    <option value="en">English</option>
    <option value="de">German</option>
    <option value="nl">Dutch</option>
    <option value="fr">French</option>
  </select>
</div>
    </ng-template>
    <ng-template #end>
      <button
        pButton
        type="button"
        icon="pi pi-arrow-left"
        label="Back"
        class="p-button-sm p-button-secondary ml-2"
        (click)="goBack()"
      ></button>
    </ng-template>
  </p-toolbar>
</div>

<div
    *ngIf="showFrancePicklistNotReadyBanner"
    class="france-picklist-not-ready-banner"
>
    <div class="france-picklist-not-ready-banner__text">
        <i class="pi pi-clock" aria-hidden="true"></i>
        <div>
            <strong>Picklist PDF not ready yet</strong>
            <p>
                The document is not in IDM yet. You can still Change and Create Invoice or Generate Invoice;
                refresh when the PDF appears.
            </p>
        </div>
    </div>
    <div class="france-picklist-not-ready-banner__actions">
        <button
            *ngIf="canShowProcessPicklist"
            pButton
            type="button"
            icon="pi pi-check-square"
            label="Change and Create Invoice"
            class="p-button-sm"
            [disabled]="processPicklistLoading || processPicklistProcessing || processPicklistConfirming"
            (click)="openProcessPicklist()"
        ></button>
        <button
            *ngIf="canShowProcessPicklist"
            pButton
            type="button"
            icon="pi pi-verified"
            label="Generate Invoice"
            class="p-button-sm"
            [disabled]="processPicklistLoading || processPicklistProcessing || processPicklistConfirming"
            (click)="requestConfirmPicklistFromToolbar()"
        ></button>
        <button
            pButton
            type="button"
            icon="pi pi-refresh"
            label="Refresh"
            class="p-button-sm p-button-outlined"
            (click)="retryM3DeliveryNote()"
        ></button>
    </div>
</div>

<p-dialog
    [(visible)]="franceConfirmSuccessDialogVisible"
    [modal]="true"
    [closable]="false"
    [dismissableMask]="false"
    [closeOnEscape]="false"
    [style]="{ width: '520px' }"
    styleClass="france-confirm-success-dialog"
    (onHide)="onFranceConfirmSuccessDialogHide()"
>
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-3">
            <span class="france-confirm-success-icon"><i class="pi pi-check-circle"></i></span>
            <span class="france-confirm-success-title">Picklist Confirmed</span>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="france-confirm-success-content">
            <p class="france-confirm-success-lead">
                Invoice will be generated within a few minutes.
            </p>
            <div class="france-confirm-success-status">
                Redirecting in
                <strong>{{ franceConfirmRedirectSeconds }}</strong>s
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button
            label="Back to Orders"
            icon="pi pi-arrow-left"
            styleClass="p-button-primary"
            [disabled]="franceConfirmNavigating"
            (click)="goToOrders1FromFranceConfirmSuccess()"
        ></p-button>
    </ng-template>
</p-dialog>

<p-dialog
    [(visible)]="picklistInProgressDialogVisible"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="true"
    [style]="{ width: '520px' }"
    styleClass="picklist-in-progress-dialog"
    (onHide)="closePicklistInProgressDialog()"
>
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-3">
            <span class="picklist-in-progress-icon"><i class="pi pi-clock"></i></span>
            <span class="text-xl font-semibold">Picklist Not Ready</span>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="picklist-in-progress-content">
            <p class="mb-2">
                The picklist PDF is not available in IDM yet (M3 may still be generating it).
            </p>
            <p class="mb-0 text-color-secondary">
                You can still <strong>Change and Create Invoice</strong> or generate the invoice.
                Use Refresh when the document appears.
            </p>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button
            *ngIf="canShowProcessPicklist"
            label="Change and Create Invoice"
            icon="pi pi-check-square"
            styleClass="p-button-primary"
            [disabled]="processPicklistLoading || processPicklistProcessing || processPicklistConfirming"
            (click)="openProcessPicklistFromNotReady()"
        ></p-button>
        <p-button
            *ngIf="canShowProcessPicklist"
            label="Generate Invoice"
            icon="pi pi-verified"
            styleClass="p-button-secondary"
            [disabled]="processPicklistLoading || processPicklistProcessing || processPicklistConfirming"
            (click)="requestConfirmPicklistFromToolbar()"
        ></p-button>
        <p-button
            label="Refresh now"
            icon="pi pi-refresh"
            styleClass="p-button-outlined"
            (click)="retryPicklistFetch()"
        ></p-button>
        <p-button
            label="Go back"
            icon="pi pi-arrow-left"
            styleClass="p-button-text p-button-secondary"
            (click)="closePicklistInProgressAndGoBack()"
        ></p-button>
    </ng-template>
</p-dialog>

<p-dialog
    [(visible)]="creditLimitProceedDialogVisible"
    [modal]="true"
    [style]="{ width: '26rem' }"
    styleClass="credit-limit-dialog"
    [closable]="true"
    (onHide)="onCreditLimitProceedCancel()"
>
    <ng-template pTemplate="header">
        <span *ngIf="creditLimitDialogKind === 'overdue'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Overdue Balance</span>
        </span>
        <span *ngIf="creditLimitDialogKind === 'both'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Credit Limit 3 &amp; 4 Exceeded</span>
        </span>
        <span *ngIf="creditLimitDialogKind === 'exposure'" class="credit-limit-dialog-header credit-limit-dialog-header--warning">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            <span>Credit Limit Warning</span>
        </span>
    </ng-template>
    <app-credit-limit-dialog-content
        [kind]="creditLimitDialogKind"
        [data]="creditLimitDialogData"
        [nood]="creditLimitDialogNood"
        [odud]="creditLimitDialogOdud"
        [note]="creditLimitProceedNote"
    ></app-credit-limit-dialog-content>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" severity="secondary" (onClick)="onCreditLimitProceedCancel()"></p-button>
        <p-button label="Continue to Picking List" icon="pi pi-arrow-right" (onClick)="onCreditLimitProceedAccept()"></p-button>
    </ng-template>
</p-dialog>
<p-dialog
    [(visible)]="creditLimitBlockedDialogVisible"
    [modal]="true"
    [style]="{ width: '26rem' }"
    styleClass="credit-limit-dialog"
    [closable]="true"
    (onHide)="onCreditLimitBlockedDialogClose()"
>
    <ng-template pTemplate="header">
        <span *ngIf="creditLimitDialogKind === 'overdue'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Overdue Balance</span>
        </span>
        <span *ngIf="creditLimitDialogKind === 'both'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Credit Limit 3 &amp; 4 Exceeded</span>
        </span>
        <span *ngIf="creditLimitDialogKind === 'exposure'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Credit Limit Exceeded</span>
        </span>
    </ng-template>
    <app-credit-limit-dialog-content
        [kind]="creditLimitDialogKind"
        [data]="creditLimitDialogData"
        [nood]="creditLimitDialogNood"
        [odud]="creditLimitDialogOdud"
        [note]="creditLimitBlockedNote"
    ></app-credit-limit-dialog-content>
    <ng-template pTemplate="footer">
        <p-button label="OK" icon="pi pi-check" (onClick)="onCreditLimitBlockedDialogClose()"></p-button>
    </ng-template>
</p-dialog>
<p-dialog
    [(visible)]="processPicklistDialogVisible"
    [modal]="true"
    [style]="{ width: 'min(96vw, 72rem)' }"
    styleClass="process-picklist-dialog"
    [closable]="!processPicklistProcessing && !processPicklistConfirming"
    [draggable]="false"
    header="Change and Create Invoice"
    (onHide)="closeProcessPicklistDialog()"
>
    <div class="process-picklist-meta">
        <div>
            <span class="process-picklist-meta__label">Order</span>
            <strong>{{ processPicklistPreviewOrno || item?.referenceOrderId || '—' }}</strong>
            <span *ngIf="processPicklistProgress" class="process-picklist-meta__progress">
                {{ processPicklistProgress }}
            </span>
        </div>
        <input
            *ngIf="processPicklistGroups?.length"
            pInputText
            type="text"
            class="process-picklist-meta__search"
            [(ngModel)]="processPicklistSearch"
            placeholder="Search..."
            [disabled]="processPicklistProcessing"
        />
    </div>

    <div *ngIf="!processPicklistGroups?.length" class="process-picklist-empty">
        No M3 picklists were returned for this order.
    </div>

    <div *ngFor="let group of processPicklistGroups; let gi = index" class="process-picklist-group">
        <div class="process-picklist-group__title">
            Picklist {{ gi + 1 }}
            <span class="process-picklist-group__sub">Delivery {{ group.dlix }} · List {{ group.plsx }}</span>
        </div>

        <div *ngIf="!group.lines?.length" class="process-picklist-empty process-picklist-empty--inline">
            No pick lines for this delivery / picking list.
        </div>

        <ng-container *ngIf="group.lines?.length">
        <div
            *ngIf="getVisibleProcessLines(group) as visibleLines"
        >
        <div
            *ngIf="!visibleLines.length"
            class="process-picklist-empty process-picklist-empty--inline"
        >
            No lines match the current search or filter.
        </div>

        <p-table
            *ngIf="visibleLines.length"
            [value]="visibleLines"
            styleClass="p-datatable-sm process-picklist-table"
            [tableStyle]="{ 'min-width': '100%' }"
            [scrollable]="true"
            scrollHeight="22rem"
            sortField="itemNumber"
            [sortOrder]="1"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 5.5rem;" pSortableColumn="itemNumber">
                        Item <p-sortIcon field="itemNumber" />
                    </th>
                    <th>Description</th>
                    <th style="width: 5rem;">Line</th>
                    <th style="width: 7rem;">Location</th>
                    <th style="width: 9rem;">Lot</th>
                    <th style="width: 5rem;" title="Order quantity (ORQT)">Ordered</th>
                    <th style="width: 5rem;" title="Physically picked / pick-list qty (TRQT)">Picked</th>
                    <th style="width: 6.5rem;" title="Quantity to send to customer">Ship Qty</th>
                    <th style="width: 7.5rem;">Status</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-line>
                <tr
                    [class.process-picklist-row--changed]="isProcessLineChanged(line) && !line.validationError"
                    [class.process-picklist-row--invalid]="!!line.validationError"
                >
                    <td>{{ line.itemNumber || '—' }}</td>
                    <td class="process-picklist-desc" [title]="line.itemDescription">{{ line.itemDescription || '—' }}</td>
                    <td>{{ line.orderLine || '—' }}</td>
                    <td>{{ line.whsl || '—' }}</td>
                    <td class="process-picklist-lot" [title]="line.bano">{{ line.bano || '—' }}</td>
                    <td>{{ line.orderedQuantity }}</td>
                    <td class="process-picklist-picked">{{ line.originalQuantity }}</td>
                    <td class="process-picklist-qty">
                        <p-inputNumber
                            [(ngModel)]="line.editableQuantity"
                            [min]="0"
                            [max]="maxShipQty(line)"
                            [minFractionDigits]="0"
                            [maxFractionDigits]="3"
                            [disabled]="processPicklistProcessing"
                            [useGrouping]="false"
                            (onInput)="onProcessShipQtyChange(line)"
                            (onBlur)="onProcessShipQtyChange(line)"
                            [showButtons]="false"
                            inputStyleClass="process-picklist-qty-input"
                            [class.ng-invalid]="!!line.validationError"
                        ></p-inputNumber>
                    </td>
                    <td>
                        <p-tag
                            *ngIf="line.processingStatus === 'SUCCESS'"
                            severity="success"
                            value="Done"
                        ></p-tag>
                        <p-tag
                            *ngIf="line.processingStatus === 'FAILED' || line.processingStatus === 'CONFIRM_FAILED'"
                            severity="danger"
                            value="Failed"
                            [title]="line.validationError || ''"
                        ></p-tag>
                        <p-tag
                            *ngIf="!line.processingStatus && line.validationError"
                            severity="danger"
                            value="Invalid"
                            [title]="line.validationError"
                        ></p-tag>
                        <p-tag
                            *ngIf="!line.processingStatus && !line.validationError && isProcessLineChanged(line)"
                            severity="warn"
                            value="Changed"
                        ></p-tag>
                        <span
                            *ngIf="!line.processingStatus && !line.validationError && !isProcessLineChanged(line)"
                            class="process-picklist-status-muted"
                        >—</span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        </div>
        </ng-container>
    </div>

    <div *ngIf="processPicklistResults?.length" class="process-picklist-results">
        <div class="process-picklist-results__title">Processing results</div>
        <div *ngFor="let r of processPicklistResults" class="process-picklist-results__row">
            <i
                class="pi"
                [ngClass]="r.status === 'SUCCESS' ? 'pi-check-circle process-ok' : 'pi-times-circle process-fail'"
            ></i>
            <span>
                Item {{ r.itemNumber || '—' }}
                <span *ngIf="r.plrn"> (PLRN {{ r.plrn }})</span>
                — {{ r.status }}
                <span *ngIf="r.errorMessage">: {{ r.errorMessage }}</span>
            </span>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="process-picklist-footer">
            <div class="process-picklist-footer__summary">
                <span>Changed: {{ changedProcessLineCount }}</span>
                <span *ngIf="processPicklistInvalidCount" class="process-picklist-footer__invalid">
                    Invalid: {{ processPicklistInvalidCount }}
                </span>
            </div>
            <div class="process-picklist-footer__actions">
                <p-button
                    label="Cancel"
                    icon="pi pi-times"
                    severity="secondary"
                    [disabled]="processPicklistProcessing || processPicklistConfirming"
                    (onClick)="closeProcessPicklistDialog()"
                ></p-button>
                <p-button
                    label="Confirm without changes"
                    icon="pi pi-verified"
                    severity="secondary"
                    [outlined]="true"
                    [disabled]="!canConfirmPicklistWithoutChanges"
                    (onClick)="requestConfirmPicklistFromPopup()"
                ></p-button>
                <p-button
                    [label]="processPicklistProcessButtonLabel"
                    icon="pi pi-check"
                    [disabled]="!canSubmitProcessPicklist"
                    (onClick)="requestProcessPicklistChanges()"
                ></p-button>
            </div>
        </div>
    </ng-template>
</p-dialog>

<p-dialog
    [(visible)]="processPicklistConfirmVisible"
    [modal]="true"
    [style]="{ width: '32rem' }"
    styleClass="process-picklist-confirm-dialog"
    header="Confirm & Process"
    [closable]="!processPicklistProcessing"
>
    <p>You are about to update {{ changedProcessLineCount }} picking-list line(s) in M3. Continue?</p>
    <div class="process-picklist-confirm-list">
        <div *ngFor="let line of changedProcessLines" class="process-picklist-confirm-item">
            <strong>{{ line.itemNumber }}</strong>
            <span>
                Ordered {{ line.orderedQuantity }} · Picked {{ line.originalQuantity }} → Ship {{ line.editableQuantity }}
            </span>
            <span class="process-picklist-confirm-remain">(unshipped {{ remainingQty(line) }})</span>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button
            label="Cancel"
            icon="pi pi-times"
            severity="secondary"
            [disabled]="processPicklistProcessing"
            (onClick)="processPicklistConfirmVisible = false"
        ></p-button>
        <p-button
            label="Confirm & Process"
            icon="pi pi-check"
            [disabled]="processPicklistProcessing"
            (onClick)="confirmAndProcessPicklistChanges()"
        ></p-button>
    </ng-template>
</p-dialog>

<p-dialog
    [(visible)]="confirmOnlyDialogVisible"
    [modal]="true"
    [style]="{ width: '32rem' }"
    styleClass="process-picklist-confirm-dialog"
    header="Generate Invoice"
    [closable]="!processPicklistConfirming"
>
    <p>
        Confirm picklist(s) in M3 <strong>without</strong> changing ship quantities.
        This is for orders that are ready to proceed (e.g. invoicing) with no short-pick.
    </p>
    <p *ngIf="confirmOnlyPicklistCount > 0" class="text-color-secondary">
        {{ confirmOnlyPicklistCount }} picklist(s) will be confirmed.
    </p>
    <p *ngIf="confirmOnlyPicklistCount === 0" class="text-color-secondary">
        M3 picklists will be resolved automatically for this order.
    </p>
    <ng-template pTemplate="footer">
        <p-button
            label="Cancel"
            icon="pi pi-times"
            severity="secondary"
            [disabled]="processPicklistConfirming"
            (onClick)="confirmOnlyDialogVisible = false"
        ></p-button>
        <p-button
            label="Generate Invoice"
            icon="pi pi-verified"
            [disabled]="processPicklistConfirming"
            (onClick)="executeConfirmPicklistOnly()"
        ></p-button>
    </ng-template>
</p-dialog>

<!-- France (300) synced: IDM Ruestliste PDFs. All loaded; one visible at a time. -->
<div *ngIf="!creditLimitBlocked && useM3DeliveryNote" class="m3-delivery-note-viewer" style="width: 100%; margin: 24px auto;">
  <div *ngIf="m3DeliveryNoteError" style="padding: 16px; color: #b45309;">
    {{ m3DeliveryNoteError }}
  </div>
  <div *ngIf="m3DeliveryNoteLoaded && deliveryNotePdfUrls.length > 1" style="display: flex; gap: 8px; margin-bottom: 12px; flex-wrap: wrap;">
    <p-button
      *ngFor="let pdf of deliveryNotePdfUrls; let i = index"
      [label]="'Picklist ' + (i + 1)"
      [outlined]="i !== selectedDeliveryNoteIndex"
      (onClick)="selectDeliveryNote(i)">
    </p-button>
  </div>
  <iframe
    *ngIf="m3DeliveryNoteLoaded && deliveryNotePdfUrls[selectedDeliveryNoteIndex]"
    [src]="deliveryNotePdfUrls[selectedDeliveryNoteIndex]"
    title="M3 Picklist"
    style="width: 100%; height: 900px; border: 1px solid #ddd; border-radius: 6px;">
  </iframe>
</div>

<div #pickingList *ngIf="!creditLimitBlocked && !useM3DeliveryNote">
  <div *ngFor="let pageLines of paginatedContent; let i = index">
    <div class="invoice-wrapper"
         [class.last-page]="i === paginatedContent.length - 1 && !summaryOnExtraPage">
      <div #header class="header-top">
            <img [src]="headerImage" class="logo" />
          </div>
      <div class="main-content">
        <div class="address-invoice-row">
          <div class="address-block">
            <div>{{this.item?.customerName}}</div>
            <div *ngFor="let line of getAddressLines(customerDetails.CUA1)">
                {{ line }}
            </div>
            <div *ngFor="let phone of getPhoneLines(customerDetails.phoneNumber)">
                {{ phone }}
            </div>
          </div>
          <div class="invoice-block">
            <div class="invoice-title"><b>{{ getLabel('pickingListTitle') }}</b></div>
            <table>
              <tr>
                <td>{{ getLabel('orderNumber') }}</td>
                <td>:</td>
                <td>{{ pickingListDetails.orderNumber }}</td>
              </tr>
              <tr>
                <td>{{ getLabel('referenceOrderNumber') }}</td>
                <td>:</td>
                <td>{{ pickingListDetails.referenceOrderNumber }}</td>
              </tr>
              <tr>
                <td>{{ getLabel('customerNo') }}</td>
                <td>:</td>
                <td>{{ pickingListDetails.customerNo }}</td>
              </tr>
              <tr>
                <td>{{ getLabel('date') }}</td>
                <td>:</td>
                <td>{{ pickingListDetails.date }}</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="prepost-block" *ngFor="let text of pageHeaderPres(pageLines)">
          <span class="prepost-block__label">Pre:</span>{{ text }}
        </div>

        <table class="items-table">
          <thead>
            <tr>
              <th>{{ getLabel('lineNo') }}</th>
              <th>{{ getLabel('itemNo') }}</th>
              <th>{{ getLabel('quantity') }}</th>
              <th>{{ getLabel('itemName') }}</th>
              <th>{{ getLabel('pcs') }}</th>
              <th>{{ getLabel('size') }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let row of pageTableRows(pageLines)">
              <tr *ngIf="row.kind === 'item'" [ngClass]="{'bold-row': row.line.itemGroup === '11000'}">
                <td>{{ row.line.displayNo }}</td>
                <td>{{ row.line.itemNo }}</td>
                <td>{{ row.line.quantity }}</td>
                <td>{{ row.line.description }}</td>
                <td>{{ row.line.pcs }}</td>
                <td>{{ row.line.size }}</td>
              </tr>
              <tr *ngIf="row.kind === 'linePre'" class="prepost-row prepost-row--pre">
                <td colspan="6"><span class="prepost-block__label">Pre:</span>{{ row.text }}</td>
              </tr>
              <tr *ngIf="row.kind === 'linePost'" class="prepost-row prepost-row--post">
                <td colspan="6"><span class="prepost-block__label">Post:</span>{{ row.text }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>

        <div class="prepost-block" *ngFor="let text of pageHeaderPosts(pageLines)">
          <span class="prepost-block__label">Post:</span>{{ text }}
        </div>

        <ng-container *ngIf="i === paginatedContent.length - 1 && !summaryOnExtraPage && div1 !== '400'">
          <div class="total-row left-align">
            <table class="invoice-summary" style="margin-top: 20px">
              <tr>
                <td><strong>{{ getLabel('packages') }}</strong></td>
                <td style="text-align: right; font-weight: normal;">{{ getTotalQuantity() }}</td>
              </tr>
              <tr>
                <td><strong>{{ getLabel('grossWeight') }}</strong></td>
                <td style="text-align: right; font-weight: normal;">{{ totalGrossWeight | number:'1.2-2' }} kg</td>
              </tr>
              <tr>
                <td><strong>{{ getLabel('netWeight') }}</strong></td>
                <td style="text-align: right; font-weight: normal;">{{ totalNetWeight | number:'1.2-2' }} kg</td>
              </tr>
            </table>
          </div>
        </ng-container>
      </div>
      <div class="watermark-footer">
  <img src="assets/torna_logo.png" alt="Watermark" />
</div>
      <div #footer class="footer avoid-break">
            <img [src]="footerImage" class="footer-logo" />
          </div>
    </div>
  </div>
  <!-- Print-only: summary page when wrap-aware print pagination leaves no room on last item page -->
  <div *ngIf="summaryOnExtraPage && div1 !== '400'">
    <div class="invoice-wrapper last-page" style="display: flex; flex-direction: column; min-height: 297mm;">
      <div class="header-top">
        <img [src]="headerImage" class="logo" />
      </div>
      <div class="main-content" style="flex: 1 0 auto;">
        <div class="total-row left-align">
          <table class="invoice-summary" style="margin-top: 20px">
            <tr>
              <td><strong>{{ getLabel('packages') }}</strong></td>
              <td style="text-align: right; font-weight: normal;">{{ getTotalQuantity() }}</td>
            </tr>
            <tr>
              <td><strong>{{ getLabel('grossWeight') }}</strong></td>
              <td style="text-align: right; font-weight: normal;">{{ totalGrossWeight | number:'1.2-2' }} kg</td>
            </tr>
            <tr>
              <td><strong>{{ getLabel('netWeight') }}</strong></td>
              <td style="text-align: right; font-weight: normal;">{{ totalNetWeight | number:'1.2-2' }} kg</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="watermark-footer">
        <img src="assets/torna_logo.png" alt="Watermark" />
      </div>
      <div class="footer avoid-break">
        <img [src]="footerImage" class="footer-logo" />
      </div>
    </div>
  </div>
</div>

